import HomeCard from "./homeCard";
import PopUpFormNotify from "../../../popUpForms/popUpFormNotify";

const bulletPoints = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "An opportunity to showcase your innovation in wildfire prevention",
];

const bulletPoints2 = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "New innovations with great impact potential",
];

const bulletPoints3 = [
  "Exposure to industry leaders, investors and collaborators",
  "Valuable networking opportunities",
  "An opportunity to showcase your innovation in wildfire prevention",
  "New innovations with great impact potential",
];

// The card to appear after the showcase before the new showcase date is set

const CardInnovatorShowcasePost = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="showcase"
      title="Wildfire Innovation Showcase"
      titleColor="var(--orange)"
      image="./images/home/card-innovative-showcase.jpg"
      popUpComponent={<PopUpFormNotify />}
      content={[
        {
          type: "header-H4",
          color: "var(--gold)",
          text: `Sign up to Present or Attend!`,
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: `Hosted by the Catastrophic Wildfire Prevention Consortium, in
          collaboration with <a href="https://venturestarters.com/" target="_blank"> Venture Starters</a>.`,
        },
        {
          type: "header-H4",
          color: "var(--green)",
          text: `Featuring trailblazing ventures`,
        },
        {
          type: "list",
          headerColor: "var(--cornflower-blue)",
          header: "Unlock your potential through:",
          list: bulletPoints3,
        },
        {
          type: "paragraph",
          text: '<a href="/showcase/innovations">Learn more ...</a>',
          color: "var(--white)",
        },
        {
          type: "paragraph",
          text: 'Our previous Showcases garnered great reception with over 200 guests and 6,500+ views! <a href="https://www.youtube.com/watch?v=4jI0sPQ19Cg&ab_channel=CatastrophicWildfirePreventionConsortium" target="_blank">Viewable on YouTube</a>.',
        },
        {
          type: "button",
          text: "Apply to Present",
          link: "https://docs.google.com/forms/d/e/1FAIpQLSeSs3XsYEIguFjQ4i9jBQ9nxmYNmNDnhbv_q4qeOtQzWani4g/viewform",
          color: "var(--green)",
        },
        {
          type: "button",
          text: "Notify Me",
          color: "var(--orange)",
        },
        {
          type: "paragraph",
          text: 'Questions: <a href="mailto:contact@preventwildfire.world" class="contact-email">contact@preventwildfire.world<a> ',
        },
      ]}
    />
  );
};

export default CardInnovatorShowcasePost;
